module.exports = __webpack_public_path__ + "img/1440.3f25e644.jpg";